import * as z from "zod";
import { readStepConfig } from "../commitFiles";
import { ensureWritable, modifyStepConfig } from "../copyOnWrite";
import { mutator } from "./mutator";
import { branchSchema } from "./utils";

export const toggleStepRoutePin = mutator({
  schema: z
    .object({
      stepDir: z.string(),
    })
    .merge(branchSchema),
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    const {
      stepDir,
      branch,
      forkBranchId,
      forkCommitId,
      forkChatId,
      workingCommitId,
      workingChatId,
    } = args;
    const { commitId } = await ensureWritable(
      tx,
      ctx,
      ctx.tenantId,
      {
        branchId: branch.id,
        forkBranchId,
        forkCommitId,
        forkChatId,
        workingCommitId,
        workingChatId,
      },
      branch
    );
    const current = await readStepConfig({ tx, commitId }, stepDir);
    await modifyStepConfig(tx, commitId, ctx.tenantId, stepDir, {
      pinned: !current.pinned,
    });
  },
});
